export default __webpack_public_path__ + "static/media/home.beb3e8c0.webp";